import {
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
  } from "@chakra-ui/react";
  import React, { useMemo, useState } from "react";
  
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import moment from "moment";
  import { poNumberFormate } from "jsFunctions/helperFunctions";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
  import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
  

  const DataRow = ({ label, value, type }) => {
    return (
      <>
          <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">₹</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const GstInfoModel = ({ openInfoModal, closeInfoModal, selectedItem, role }) => {
    const [activeTab, setActiveTab] = useState("information");

    const getPoMonth = useMemo(() => {
      if (selectedItem.orderMonth) {
        const date = moment(selectedItem.orderMonth);
        const month = date.format("MMM");
        const year = date.format("YYYY");
        return `${year}-${month}`;
      }
      return "";
    }, [selectedItem.orderMonth]);
      
  
    
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent  
          top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>GST Information</span>
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5"> Purchase Order Details</h5>
  
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Order Number"
                            value={poNumberFormate(selectedItem.poNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Order Month" value={getPoMonth} />
                        </Col>
                      </Row>
                      
                      
                     
                    
                   
                       
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">GST Applicable</h5>
                    <Row className="info-row">
                      <Col className="check-cross-mark mt-0">
                        <Form.Label>
                          <span
                            className="checkmark"
                          ></span>{" "}
                          Is GST applicable?
                        </Form.Label>
                      </Col>
                    
                    </Row>
                    
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Company Name"
                            value={selectedItem?.gstFields?.companyName}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="GST Number"
                            value={selectedItem?.gstFields?.gstNumber}
                          />
                        </Col>
                       
                      </Row>
                      <Row className="info-row">
                     <Col>
                     <DataRow
                            label="Base Amount"
                            value={Number(selectedItem.gstFields.baseAmount || 0)}
                            type='Amount'

                          />
                        </Col>
                        <Col></Col>
                     </Row>
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="IGST"
                            value={selectedItem.gstFields.gstAmount?.i}
                            type='Amount'

                          />
                        </Col>
                      <Col>
                          <DataRow
                            label="SGST"
                            value={selectedItem.gstFields.gstAmount?.s}
                            type='Amount'

                          />
                        </Col>
                        
                    </Row>
                    <Row className="info-row">
                    <Col>
                          <DataRow
                            label="CGST"
                            value={selectedItem.gstFields.gstAmount?.c}
                            type='Amount'

                          />
                        </Col>
                   
                      <Col>
                          <DataRow
                            label="Total GST"
                            value={Number(selectedItem.gstFields.gstAmount?.c) + Number(selectedItem.gstFields.gstAmount?.s) + Number(selectedItem.gstFields.gstAmount?.i)}
                            type='Amount'

                          />
                        </Col>
                       
                    </Row>
                   
                    </div>
                  </Tab>
                 <Tab
                  eventKey=""
                  title=""
                  disabled
                  className="main-tab-item"
                 >

                 </Tab>
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default GstInfoModel;
  